import { IconsEnum } from '../../../../../../assets/icons/types';
import { Icon } from '../../../../../../helpers/Icon';
import { Translate } from '../../../../../../helpers/Translate';
import { modelViewersKeys, words } from '../../../../../../locales/keys';
import { ComposerUnits } from '../../../../composerTypes';
import { DisplaySettingsMenuItem } from '../DisplaySettingsMenuItem';

interface DisplaySettingsUnitsPanelProps {
  units: ComposerUnits;
  onBack: () => void;
  onSelect: (units: ComposerUnits) => void;
}

function DisplaySettingsUnitsPanel({
  units,
  onBack,
  onSelect
}: DisplaySettingsUnitsPanelProps) {
  return (
    <div className="flex flex-col w-full">
      <button
        type="button"
        className="px-1 block w-full group/menu-item"
        role="menuitem"
        onClick={onBack}
      >
        <div className="px-2 py-1 dark:group-hover/menu-item:bg-gray-800 group-hover/menu-item:bg-gray-100 rounded min-h-7">
          <div className="flex items-center gap-2 text-md sm:text-sm">
            <Icon className="h-4 w-4" icon={IconsEnum.CHEVRON_LEFT} />
            <span className="mr-auto font-normal sm:font-medium block truncate leading-5 text-left">
              <Translate id={words.changeUnits} />
            </span>
          </div>
        </div>
      </button>
      <hr className="border-gray-200 dark:border-gray-600 my-1" />
      <DisplaySettingsMenuItem
        icon={IconsEnum.UNITS_METRIC_CM_SOLID}
        label={<Translate id={modelViewersKeys.unitsMetric} />}
        selected={units === ComposerUnits.CM}
        onClick={() => onSelect(ComposerUnits.CM)}
      />
      <DisplaySettingsMenuItem
        icon={IconsEnum.UNITS_METRIC_IN_SOLID}
        label={<Translate id={modelViewersKeys.unitsImperial} />}
        selected={units === ComposerUnits.IN}
        onClick={() => onSelect(ComposerUnits.IN)}
      />
    </div>
  );
}

export default DisplaySettingsUnitsPanel;
